export const title = 'Subscribe';

export const link = 'Yes I’d like to subscribe';
